import gql from "graphql-tag"
import { Startup, StartupSnapshotFields } from "../types"

export interface Data {
  startup: Pick<Startup, "id" | "name"> & StartupSnapshotFields
}

export interface Variables {
  where?: { slug?: string; id?: string }
}

export const STARTUP = gql`
  query startup($where: StartupWhereUniqueInput) {
    startup(where: $where) {
      id
      name
      slug
      logoImageId
      slogan
      websiteUrl
      locationCountry
      industry
      verticals
      customerFocus
      stage
      seekingFunding
      problemToSolve
      problemSolution
      marketDescription
      valueProposition
      businessModel
      competitionDescription
      pressAndAwardsUrls
      twitterUrl
      facebookUrl
      linkedinUrl
      previousFundingRounds
      currentFundingRound
      fundingUsesAndRunway
      recurringRevenueValue
      recurringRevenueTimeframe
      valuation
      dealType
      investorPreferences
      userCount
      growthRateValue
      growthRateTimeframe
      churnRateValue
      churnRateTimeframe
      ltvCacRatio
      contractsInPipelineCount
      investmentAsk
      pitchDeckUrl
      countryOfIncorporation
      yearFounded
      businessModelTypes
      burnRate
      burnRateTimeframe
      revenueGrowthRate
      revenueGrowthRateTimeframe
      ltv
      cac
      dailyActiveUsers
      customerCount
      annualSignedContractValue
      profileCompletenessPercentage
      highlightedMetricValue
      highlightedMetricUnitLabel
      teamMembers {
        name
        role
        skills
        description
        linkedinUrl
      }
    }
  }
`
